import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function KPICards({
  label,
  value,
  trend,
  bgColor = "#F9FAFB", // gray-50
  onClick,
}) {
  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: bgColor,
        transition: "all 0.2s ease",
        cursor: onClick ? "pointer" : "default",
        boxShadow: onClick ? "0 0 0 rgba(0,0,0,0)" : "none",
        border: "1px solid #D1D5DB", // added slightly darker border (gray-300)
      }}
      onMouseEnter={(e) => {
        if (onClick) e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        if (onClick) e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Label */}
      <div
        style={{
          fontSize: "12px",
          fontWeight: 500,
          color: "#4B5563", // gray-600
          marginBottom: "8px",
        }}
      >
        {label}
      </div>

      {/* Value + Trend */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        {/* Value */}
        <div
          style={{
            fontSize: "24px",
            fontWeight: 700,
            color: "#111827", // gray-900
          }}
        >
          {value}
        </div>

        {/* Trend */}
        {trend !== undefined && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "12px",
              fontWeight: 500,
              color: trend >= 0 ? "#16A34A" : "#DC2626",
            }}
          >
            {trend >= 0 ? <ArrowUp size={12} /> : <ArrowDown size={12} />}
            <span>{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
    </div>
  );
}
